/*
 * Cart drawer "You may also like" behaviour.
 *
 * Loaded from layout/theme.liquid rather than the snippet, because the cart
 * drawer is re-rendered through the Section Rendering API and script tags
 * injected that way never execute. The listener is delegated on document, so
 * it survives every drawer re-render.
 */
(function () {
  if (window.__cartRecsBound) return;
  window.__cartRecsBound = true;

  function refreshDrawer(sections) {
    var html = sections && sections['cart-drawer-section'];
    if (!html) {
      window.location.reload();
      return;
    }

    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('[data-hydration-key="cart-drawer-inner"]');
    var current = document.querySelector('[data-hydration-key="cart-drawer-inner"]');

    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
    } else {
      window.location.reload();
    }
  }

  function addVariant(variantId, button) {
    if (!variantId) return;

    button.setAttribute('disabled', 'disabled');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: ['cart-drawer-section']
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        refreshDrawer(data.sections);
      })
      .catch(function () {
        window.location.reload();
      });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var toggle = target.closest('[data-cart-recs-toggle]');
    if (toggle) {
      event.preventDefault();

      var single = toggle.getAttribute('data-variant-id');
      if (single) {
        addVariant(single, toggle);
        return;
      }

      var card = toggle.closest('[data-cart-recs-card]');
      var picker = card && card.querySelector('[data-cart-recs-picker]');
      if (picker) {
        picker.hidden = !picker.hidden;
        toggle.textContent = picker.hidden ? '+' : '–';
      }
      return;
    }

    var option = target.closest('[data-cart-recs-option]');
    if (option) {
      event.preventDefault();

      var wrap = option.closest('[data-cart-recs-picker]');
      if (wrap) {
        var siblings = wrap.querySelectorAll('[data-cart-recs-option]');
        for (var i = 0; i < siblings.length; i++) {
          siblings[i].classList.remove('is-selected');
        }

        var confirm = wrap.querySelector('[data-cart-recs-add]');
        if (confirm) {
          confirm.removeAttribute('disabled');
          confirm.setAttribute('data-variant-id', option.getAttribute('data-variant-id'));
          confirm.textContent = 'Add to cart';
        }
      }

      option.classList.add('is-selected');
      return;
    }

    var confirmBtn = target.closest('[data-cart-recs-add]');
    if (confirmBtn) {
      event.preventDefault();
      addVariant(confirmBtn.getAttribute('data-variant-id'), confirmBtn);
    }
  });
})();
